/*
 * Vanilla replacement for ddaccordion.js (which required jQuery 1.4.2).
 * Same markup contract: .accordion_header followed by .accordion_content inside a container.
 * Behaviour kept from the old init: click to reveal, only one open at a time, first item open
 * by default, open state remembered for the session, "accordion_open" class on the open header.
 */
(function () {
  var HEADER = 'accordion_header';
  var CONTENT = 'accordion_content';
  var OPEN_CLASS = 'accordion_open';
  var STORAGE_KEY = 'lf-accordion-state';

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { return {}; }
  }
  function writeState(state) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function contentFor(header) {
    var el = header.nextElementSibling;
    while (el && !el.classList.contains(CONTENT)) el = el.nextElementSibling;
    return el;
  }
  function setOpen(header, open) {
    var content = contentFor(header);
    header.classList.toggle(OPEN_CLASS, open);
    header.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (content) content.style.display = open ? 'block' : 'none';
  }

  function init() {
    var headers = Array.prototype.slice.call(document.getElementsByClassName(HEADER));
    if (!headers.length) return;
    var state = readState();
    var groupKey = location.pathname;
    var openIndex = typeof state[groupKey] === 'number' ? state[groupKey] : 0;

    headers.forEach(function (header, index) {
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      setOpen(header, index === openIndex);

      var toggle = function () {
        var willOpen = !header.classList.contains(OPEN_CLASS);
        headers.forEach(function (other) { if (other !== header) setOpen(other, false); });
        setOpen(header, willOpen);
        state[groupKey] = willOpen ? index : -1;
        writeState(state);
      };
      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
